import { render, staticRenderFns } from "./NepszeruHirek.vue?vue&type=template&id=7af5bea8&"
import script from "./NepszeruHirek.vue?vue&type=script&lang=js&"
export * from "./NepszeruHirek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports